import { render, staticRenderFns } from "./ProjectSecondsStatisticsDonutChart.vue?vue&type=template&id=d1abc57e&"
import script from "./ProjectSecondsStatisticsDonutChart.vue?vue&type=script&lang=js&"
export * from "./ProjectSecondsStatisticsDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectSecondsStatisticsDonutChart.vue"
export default component.exports